import angular from 'angular';
import 'angular-ui-router';
import template from './gamesLogoUpload.jade';

export class GamesLogoUploadController {
  /* @ngInject */
  constructor(Upload,ModalService) {
    this.Upload = Upload;
    this.ModalService = ModalService;
  }

  handleNewFile(file) {
    if (file) {
      this.Upload.imageDimensions(file);
    }
  }

  showPreviewModal(url){
    this.ModalService.showModal({
      template: `
        <div class="c-analytics-modal is-open" ng-click="vm.close()">
          <div class="text-center u-mt++">
            <img ng-src="{{vm.url}}" />
          </div>
        </div>`,
      controllerAs: 'vm',
      controller: function(close) {
        this.url = url;
        this.close = close;
      }
    });
  }
}

export function GamesLogoUploadComponent() {
  return {
    template,
    controller: GamesLogoUploadController,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {
      game: '=',
      logo: '='
    },
    bindToController: true
  };
};

export default angular.module('app.components.admin.games.logoUpload', [
  'ngFileUpload'
])
  .directive('gamesLogoUpload', GamesLogoUploadComponent);



/** WEBPACK FOOTER **
 ** ./src/components/admin/games/gamesLogoUpload.js
 **/